import { Input, Radio } from '@popsure/dirty-swan';
import classNames from 'classnames';
import { SliderWithModal } from 'components/SliderWithModal';
import { useEffect, useState } from 'react';

import { CalculatorFieldType, FieldsValues } from '../models';
import styles from './Fields.module.scss';
import { Modal } from './Modal';

type FieldsProps = {
  fields: CalculatorFieldType[];
  onChange: (values: FieldsValues) => void;
};

const Fields = ({ fields, onChange }: FieldsProps) => {
  const [values, setValues] = useState<
    Record<string, string | number | boolean | undefined>
  >({});

  useEffect(() => {
    const newValues: FieldsValues = {};

    fields.forEach((field) => {
      const { key, props } = field;
      // eslint-disable-next-line react/prop-types
      const defaultValue = props?.defaultValue;

      if (typeof defaultValue !== 'undefined') {
        newValues[key] = defaultValue;
      }
    });

    setValues(newValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    onChange?.(values);
  }, [onChange, values]);

  return (
    <div className={`pb16 ${styles.container}`}>
      {fields.map((field) => {
        const { key, type, width = '100' } = field;

        return (
          <div key={key} className={`mt16 w${width} d-inline-block px8`}>
            {type === 'INPUT' && (
              <Input
                value={values?.[key] ? String(values?.[key]) : ''}
                onChange={(e) => {
                  setValues((prevValues) => ({
                    ...prevValues,
                    [key]:
                      field.props.type === 'number'
                        ? Number(e.target.value)
                        : String(e.target.value),
                  }));
                }}
                {...field.props}
              />
            )}

            {type === 'BOOLEAN' && (
              <>
                <label className="p-p tc-grey-600">{field.props.label}</label>
                <Radio
                  inlineLayout
                  options={{
                    YES: 'Yes',
                    NO: 'No',
                  }}
                  classNames={{
                    container: classNames('d-grid mt8', styles.radioContainer),
                  }}
                  value={
                    typeof values?.[key] === 'boolean'
                      ? values?.[key]
                        ? 'YES'
                        : 'NO'
                      : undefined
                  }
                  onChange={(booleanValue) => {
                    setValues((prevValues) => ({
                      ...prevValues,
                      [key]: booleanValue === 'YES',
                    }));
                  }}
                />
              </>
            )}

            {type === 'SLIDER' && (
              <SliderWithModal
                {...field.props}
                modalTextOverrides={field.props.modal || {}}
                value={values?.[key] ? Number(values?.[key]) : 0}
                setValue={(value) => {
                  setValues((prevValues) => ({
                    ...prevValues,
                    [key]: value,
                  }));
                }}
              />
            )}

            {type === 'MODAL' && <Modal {...field.props} />}
          </div>
        );
      })}
    </div>
  );
};

export { Fields };
